import { CamelCase } from '@rio/types'
import _camelCase from 'lodash/camelCase'

export const camelCase = <T extends string>(str: T): CamelCase<T> => {
  return _camelCase(str) as CamelCase<T>
}
